import * as PIXI from 'pixi.js'
import { CustomPIXIComponent } from 'react-pixi-fiber'

export default CustomPIXIComponent({
  customDisplayObject(props) {
    const { style } = props
    const bitmapText = new PIXI.BitmapText('', style)

    this.customApplyProps(bitmapText, {}, props)
    return bitmapText
  },

  customApplyProps(bitmapText, oldProps, newProps) {
    if (newProps.x !== undefined && newProps.x !== oldProps.x) {
      bitmapText.position.x = newProps.x
    }

    if (newProps.y !== undefined && newProps.y !== oldProps.y) {
      bitmapText.position.y = newProps.y
    }

    if (newProps.scale !== undefined && newProps.scale !== oldProps.scale) {
      if (!isNaN(newProps.scale)) {
        bitmapText.scale = { x: newProps.scale, y: newProps.scale }
      } else {
        bitmapText.scale = newProps.scale || { x: 1, y: 1 }
      }
    }

    if (newProps.anchor !== undefined && newProps.anchor !== oldProps.anchor) {
      bitmapText.anchor = newProps.anchor
    }

    if (newProps.text !== undefined && newProps.text !== oldProps.text) {
      bitmapText.text = newProps.text
    }

    if (newProps.style !== undefined && newProps.style !== oldProps.style) {
      bitmapText.style = newProps.style
    }

    if (newProps.alpha !== undefined && newProps.alpha !== oldProps.alpha) {
      bitmapText.alpha = newProps.alpha
    }

    if (newProps.rotation !== undefined && newProps.rotation !== oldProps.rotation) {
      bitmapText.rotation = newProps.rotation
    }
  }
}, 'BitmapText')
